package com.downdogapp.client

import com.downdogapp.client.singleton.Logger

interface LogEmitter {

  fun logEvent(name: String, properties: Map<String, String?> = mapOf()) {
    Logger.logEvent(eventName(name), properties)
  }

  fun logError(name: String, properties: Map<String, String?> = mapOf()) {
    Logger.logError(eventName(name), properties)
  }

  fun logClick(name: String, properties: Map<String, String?> = mapOf()) {
    Logger.logClick(eventName(name), properties)
  }

  private fun eventName(eventName: String) = "${this::class.simpleName!!}.$eventName"
}
